import { render, staticRenderFns } from "./DescriptionPopover.vue?vue&type=template&id=38dfbbaa"
import script from "./DescriptionPopover.vue?vue&type=script&lang=ts"
export * from "./DescriptionPopover.vue?vue&type=script&lang=ts"
import style0 from "./DescriptionPopover.vue?vue&type=style&index=0&id=38dfbbaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.99.8__lodash@4.17.21_prettier@2.8.8_vue-_69bc0556815cefdff9c73fe5644cf446/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DescriptionPopover.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports